import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import TabListForm from './components/TabListForm';
import useContentList from './hooks/useContentList';
import { EventDetailSectionItem } from '../../../../types/query/event/detail';
import { EventSectionListStyle } from './style';

interface IEventSectionListProps extends FormComponentProps {
  list: EventDetailSectionItem[];
  eventSectionTabKey: number | null;
  setEventSectionTabKey: React.Dispatch<React.SetStateAction<number | null>>;
}
const EventSectionList = (props: IEventSectionListProps) => {
  const { form, list, eventSectionTabKey, setEventSectionTabKey } = props;
  const contentList = useContentList({ form, sectionList: list });

  const tabList = list.map((item, index) => ({
    id: item.id,
    name: `section-item-${index}`,
    type: item.type,
    isSectionMobility: !!item.tabTitle,
  }));

  return (
    <EventSectionListStyle>
      <TabListForm
        initialValue={tabList}
        contentList={contentList}
        form={form}
        eventSectionTabKey={eventSectionTabKey}
        setEventSectionTabKey={setEventSectionTabKey}
      />
    </EventSectionListStyle>
  );
};

export default EventSectionList;
